import {
  CLEAR_OBJECT,
  SET_CHANNEL_MANAGER_LIST,
  SET_HISTORY_LIST,
  SET_HISTORY_NAV_PARAMS,
  SET_OBJECT,
  SET_OBJECT_ID,
  SET_OBJECT_PAGE,
  SET_PRICES_TYPES_LIST,
  UPDATE_ROOM_LIST,
  UPDATE_STEP_BY_STEP,
} from './constans';

let initialState = {
  photo: { photos: [], rejectedPhotos: [] },
};
let newState = null;

const objectReducers = (state = initialState, action) => {
  switch (action.type) {
    case SET_OBJECT:
      return { ...state, ...action.payload };

    case SET_OBJECT_PAGE:
      newState = { ...state };
      if (action.pageName === 'rooms') {
        newState = {
          ...newState,
          [action.pageName]: action.payload[action.pageName],
        };
      } else {
        Object.keys(action.payload).forEach((key) => {
          newState = {
            ...newState,
            [action.pageName]: {
              ...newState[action.pageName],
              [key]: action.payload[key],
            },
          };
        });
      }
      return newState;

    case CLEAR_OBJECT:
      newState = { ...state };
      Object.getOwnPropertyNames(newState).forEach(function (prop) {
        delete newState[prop];
      });
      return { ...newState };

    case UPDATE_ROOM_LIST:
      return { ...state, rooms: action.payload };

    case SET_OBJECT_ID:
      return {
        ...state,
        newObjectId: action.payload,
      };
    case SET_HISTORY_LIST:
      return {
        ...state,
        history: { ...state.history, history: action.payload },
      };
    case SET_HISTORY_NAV_PARAMS:
      return {
        ...state,
        history: { ...state.history, navParams: action.payload },
      };
    case SET_CHANNEL_MANAGER_LIST:
      return {
        ...state,
        channelManagers: action.payload,
      };
    case SET_PRICES_TYPES_LIST:
      return {
        ...state,
        pricesTypes: action.payload,
      };

    case UPDATE_STEP_BY_STEP:
      return {
        ...state,
        stepByStep: action.payload,
      };
    default:
      return state;
  }
};

export default objectReducers;
